class multiImageSlide {
  constructor(el) {
    this.el = el;
    this.slides = this.el.querySelectorAll(".slider-btn");
    this.multiImageSlides = this.el.querySelectorAll(".multi-img-slide");

    // get the index no for active element
    this.getNodeindex = elm => [...elm.parentNode.children].indexOf(elm)

    this.navigate();
    // this.BtnTextPos();
  }

  navigate() {

    for (let i = 0; i < this.slides.length; ++i) {
      let slideno = this.slides[i];
      this.slide(slideno);
    }
  }

  slide(element) {
    let self = this;
    element.addEventListener("click", function (e) {
      e.preventDefault();
      let PerentContainer = this.closest('.multi-img-slide-section');
      let activeBtn = this.getAttribute('data-view-btn');


      PerentContainer.querySelector('.slider-btn-section .active-btn').classList.remove('active-btn');

      PerentContainer.querySelector('.multi-img-slide-container .active-slide').classList.remove('active-slide');
      this.classList.add('active-btn');
      PerentContainer.querySelector('[data-view=' + activeBtn + ']').classList.add('active-slide');

      let activeSlide = PerentContainer.querySelector('.multi-img-slide.active-slide');

      // let ActiveSlideIndex = self.getNodeindex(activeSlide);

      self.slideBtnAnimate(PerentContainer);

    }, false);
  }

  slideBtnAnimate(parentElem) {
    let PerentContainer = parentElem;
    let activeHotspotSlideIndex = this.getNodeindex(PerentContainer.querySelector('.slider-btn-section .active-btn'));
    let slideBtnWidth = PerentContainer.querySelector(".slider-btn").offsetWidth;
    let selectedBtnSlidePos = (activeHotspotSlideIndex * slideBtnWidth);
    PerentContainer.querySelector(".tab-btn-trans").style.transform = 'translateX(' + selectedBtnSlidePos + 'px)';
  }


}

// function call

let domelement = document.querySelector(".multi-img-slide-section");
if (domelement && domelement != null) {
  new multiImageSlide(domelement);

  window.addEventListener("resize", function (e) {
    new multiImageSlide(domelement);
  })
}

// const dataModules = [...document.querySelectorAll('[data-module="multi-img-slide"]')];

// dataModules.forEach((element) => {
//   element.dataset.module.split(" ").forEach(function () {
//     new hotspotSlide(element);
//   });
// });